/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type { IgOHMLike, IgOHMLikeInterface } from "../IgOHMLike";

const _abi = [
  {
    inputs: [],
    name: "index",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class IgOHMLike__factory {
  static readonly abi = _abi;
  static createInterface(): IgOHMLikeInterface {
    return new utils.Interface(_abi) as IgOHMLikeInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IgOHMLike {
    return new Contract(address, _abi, signerOrProvider) as IgOHMLike;
  }
}
